<template>
  <div>
  <div class="fullWidth categorySection" v-if="bannerPlaceHolderForWhatsmore">
    <p class="whatsmore-title" v-if="renderData && renderData[0][3]">{{ renderData[0][3] }}</p>
    <div class="whatmore-base" style="min-height: 400px;">
              <div id="whatmoreShopId" :data="contentKey"></div>
              <div id="whatmoreCollection" :data="contentCategory"></div>
              <div id="whatmorePrimaryColor" data="#d97777"></div>
              <div id="whatmoreSecondaryColor" data="#d97777"></div>
              <div id="whatmoreTitleFontSize" data="28"></div>
              <div id="whatmoreLandscapePadding" data="40"></div>
              <div id="whatmoreTopBottomPadding" data="20"></div>
              <div id="whatmoreVideoTileSize" data="80"></div>
              <div id="whatmoreVideoTileSizePortrait" data="80"></div>
              <div id="whatmoreTitleFont" data="sans-serif"></div>
              <div id="whatmorePrimaryFont" data="sans-serif"></div>
              <div id="whatmoreShowViews" data="show"></div>
              <div class="whatmore-template-type" data="template-b"></div>
              <div id="whatmoreIsInDesignMode" data="false"></div>
              <div id="whatmoreUITheme" data="round"></div>
              <div class="whatmore-render-root"></div>
          </div>
      </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'whatsmore',
  props: ['renderData'],
  data () {
    return {
      contentKey: 'STRHFVBOIST',
      contentScript: 'https://d1qflh9ill7vje.cloudfront.net/whatmore.js',
      contentCategory: ''
    }
  },
  computed: {
    ...mapGetters(['bannerPlcaeHolderData', 'isSelectedCountryIndia', 'webcategory']),
    bannerPlaceHolderForWhatsmore: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'WHATS-MORE-HOME-PAGE-WEB'.toLowerCase())
    }
  },
  watch: {
    webcategory (val) {
      this.assignScriptValue(val)
    }
  },
  methods: {
    loadWhatmoreScript () {
      const existingScript = document.getElementById('whatmore-script')
      if (existingScript) {
        existingScript.remove()
      }
      const script = document.createElement('script')
      script.id = 'whatmore-script'
      script.src = this.contentScript
      script.defer = true
      document.body.appendChild(script)
      // Ensure script executes after it's loaded
      script.onload = () => {
        console.log('Whatmore script loaded and ready.')
        // If the script needs a specific initialization method, call it here.
        // Example: whatmore.init() -- Replace with actual initialization call
      }
    },
    assignScriptValue (val) {
      switch (val) {
        case 'men':
          this.contentCategory = ''
          break
        case 'women':
          // this.contentCategory = 'https://stage-site1.thesouledstore.com/women'
          this.contentCategory = 'https://www.thesouledstore.com/women' // enable this line for production and disabled above line
          break
        case 'kids':
          // this.contentCategory = 'https://stage-site1.thesouledstore.com/kids'
          this.contentCategory = 'https://www.thesouledstore.com/kids' // enable this line for production and disabled above line
          break
        default:
          this.contentCategory = ''
          break
      }
      if (this.isSelectedCountryIndia && this.bannerPlaceHolderForWhatsmore) {
        this.loadWhatmoreScript()
      }
    }
  },
  mounted () {
    if (this.webcategory) {
      this.assignScriptValue(this.webcategory)
      // if (this.isSelectedCountryIndia && this.bannerPlaceHolderForWhatsmore) {
      //   this.loadWhatmoreScript()
      // }
    }
  }
}

</script>
<style>
.fullWidth {
    width:100%;
  }
.whatsmore-title{
  font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    font-size: 1.75rem;
    text-align: center;
    color: #282c3f;
    text-transform: uppercase;
    margin: 5px;
}
</style>



// WEBPACK FOOTER //
// whatsMore.vue?03aed545